import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Dropdown,
    Header,
    Icon,
    Input,
    Label,
    Modal,
    Table,
    TextArea
} from "semantic-ui-react";
import { newSearch, newUnsavedChanges, update } from "../../reducer/actions";
import { getUnsavedChanges, isLoading } from "../../reducer";
import "./style.css";
import { getTranslate } from "react-localize-redux/lib/index";

const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    },
    positiveRow: {
        background: "#77d877 !important",
        color: "#3e7f3e !important"
    }
};


class ProductRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            counted: props.product.counted === 1,
            count: props.product.count && props.product.count >= 0 ? props.product.count : props.product.counted ? 0 : "",
            comment: props.product.comment ? props.product.comment : "",
            saved: props.product.saved,
            unsavedChanges: false,
            modalOpen: {
                comment: false
            }
        };
    }


    handleOpenModal(modal) {
        let modalOpen = this.state.modalOpen;
        modalOpen[modal] = true;
        this.setState({ modalOpen });
    }

    handleCloseModal(modal) {
        let modalOpen = this.state.modalOpen;
        modalOpen[modal] = false;
        this.setState({ modalOpen });
    }


    getDifference() {
        return this.state.count ? this.state.count - this.props.product.inStock : -this.props.product.inStock;
    }

    reset() {
        this.props.save(this.props.product.id, 0, false, "")
            .then((observation) => {
                this.setState({
                    unsavedChanges: false,
                    counted: observation.counted,
                    count: observation.count,
                    comment: observation.comment
                });
            }, () => {
                //TODO handle error
            });
    }

    save() {

        if (!this.unsavedChanges()) {
            return;
        }

        this.props.save(this.props.product.id, this.state.count === "" ? 0 : this.state.count, true, this.state.comment)
            .then((observation) => {
                this.setState({
                    unsavedChanges: false,
                    counted: observation.counted,
                    count: observation.count,
                    comment: observation.comment
                });
            });

    }

    handleCountChange(newCount) {

        if (newCount < 0) {
            newCount = 0;
        }

        this.props.newUnsaved(this.props.product.productID);

        this.setState({
            count: newCount,
        });


    }

    handleCommentChange(newComment) {

        this.setState({
            comment: newComment,
        });

    }

    saveComment() {

        this.props.newUnsaved(this.props.product.productID);

    }

    undoComment() {

        this.setState({
            comment: this.props.product.comment
        });

    }

    unsavedChanges() {

        return !!this.props.unsaved[this.props.product.productID];

    }

    render() {

        const { product } = this.props;

        return (
            <Table.Row
                key={product.id}
                className={this.unsavedChanges() ? "negativeRow" : this.state.counted ? "positiveRow" : ""}
                label={{
                    as: "a",
                    color: "red",
                    corner: "right",
                    icon: "save"
                }}>
                <Table.Cell>{product.code}</Table.Cell>
                <Table.Cell>{(this.props.noMatrix || typeof product.variations === 'undefined' || typeof product.variations[0] === 'undefined')  ? "-" : product.variations[0].code}</Table.Cell>
                <Table.Cell>{(this.props.noMatrix || typeof product.variations === 'undefined' || typeof product.variations[1] === 'undefined') ? "-" : product.variations[1].code}</Table.Cell>
                <Table.Cell>{(this.props.noMatrix || typeof product.variations === 'undefined' || typeof product.variations[2] === 'undefined') ? "-" : product.variations[2].code}</Table.Cell>
                <Table.Cell
                    className={this.getDifference() !== 0 ? "warningCell" : ""}>{this.getDifference()}</Table.Cell>
                <Table.Cell>{product.inStock}</Table.Cell>
                <Table.Cell><Input
                    loading={this.props.isLoading}
                    icon={this.state.counted && "checkmark"}
                    iconPosition='left'
                    action={this.unsavedChanges() && {
                        color: "teal",

                        labelPosition: "right",
                        icon: "save",
                        content: this.props.translate('general.save'),
                        disabled: this.props.isLoading,
                        onClick: () => {
                            this.save();
                        }
                    }}
                    type='number'
                    min={0}
                    value={this.state.count}
                    onChange={(e) => {
                        this.handleCountChange(e.target.value);
                    }}
                    onKeyPress={(event) => {
                        if (event.key === "Enter") {
                            if (this.unsavedChanges()) {

                                this.save();

                            } else {
                                if (Object.keys(this.props.unsaved).length === 0) {

                                    this.props.newSearch();
                                }
                            }
                        }
                    }}
                /></Table.Cell>
                <Table.Cell>
                    <Dropdown
                        className='icon'
                        floating
                        labeled
                        icon='chevron down'
                    >
                        <Dropdown.Menu>
                            {this.props.product.user &&
                            <Dropdown.Header icon='user'
                                             content={this.props.translate('inventory.general.lastCounted', {name: this.props.product.user}) }/>
                            }
                            {(this.state.counted || this.state.count > 0 || this.state.comment) && !this.state.saved &&
                            <Dropdown.Item text={this.props.translate('general.reset')} onClick={() => {
                                this.reset();
                            }}/>}
                            <Dropdown.Item text={this.props.translate('general.comment')} onClick={() => {
                                this.handleOpenModal("comment");
                            }}/>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Modal
                        dimmer
                        style={inlineStyle.modal}
                        open={this.state.modalOpen.comment}
                        onClose={() => {
                            this.handleCloseModal("comment");
                        }}
                    >
                        <Header content='Kommentar'/>
                        <Modal.Content>
                            <TextArea autoFocus style={{ width: "100%" }} maxLength="255"
                                      value={this.state.comment}
                                      onChange={(e) => {
                                          this.handleCommentChange(e.target.value);
                                      }}/>
                            {this.state.comment.length} / {"255"}
                        </Modal.Content>
                        <Modal.Actions>
                            <Button color='red' inverted onClick={() => {
                                this.handleCloseModal("comment");
                                this.undoComment();
                            }}>
                                <Icon name='remove'/> {this.props.translate('general.cancel')}
                            </Button>
                            <Button color='green' inverted onClick={() => {
                                this.handleCloseModal("comment");
                                this.saveComment();
                            }}>
                                <Icon name='checkmark'/> {this.props.translate('general.save')}
                            </Button>
                        </Modal.Actions>
                    </Modal>
                    {this.state.comment.length > 0 &&
                    <Label as='a' color='red' ribbon="right" onClick={()=>{this.handleOpenModal("comment");}}>
                        {this.props.translate('general.comment')}
                    </Label>
                    }

                </Table.Cell>
            </Table.Row>
        );
    }


}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    unsaved: getUnsavedChanges(state.inventory),
    isLoading: isLoading(state.inventory)
});

const mapDispatchToProps = (dispatch) => {
    return ({
        save: (id, count, counted, comment) => {
            return dispatch(update(id, count, counted, comment));
        },
        newUnsaved: (id) => {
            return dispatch(newUnsavedChanges(id));
        },
        newSearch: () => {
            return dispatch(newSearch());
        }
    });
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductRow);




// WEBPACK FOOTER //
// ./src/scenes/Inventory/components/ProductRow/index.js